export default "__VITE_ASSET__XUscqe8t__"